import { IRootState } from '../../../store'
import { ISpecialReportOptionsState } from '../store/options.types'

export const getSpecialReportDataOptionsSelector = (state: IRootState): ISpecialReportOptionsState =>
  state.options.specialReportOptions
